import { HttpErrorModel } from '@spartacus/core';
import { BetonActions } from '../actions';

export const initialState: HttpErrorModel = undefined;

export function confirmOrderErrorReducer(
  state = initialState,
  action:
    | BetonActions.ConfirmBetonOrderFail
    | BetonActions.ConfirmBetonOrderSuccess
    | BetonActions.ResetBetonOrderConfirmData,
): HttpErrorModel {
  switch (action.type) {
    case BetonActions.CONFIRM_BETON_ORDER_FAIL: {
      return action.payload;
    }

    case BetonActions.CONFIRM_BETON_ORDER_SUCCESS:
    case BetonActions.RESET_BETON_ORDER_CONFIRM_DATA: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
